import { R, asFraction, toPercentNumber, toNumber } from "../../utils/rational";
import { STATUS_NREL } from "../../utils/excel-constants";
const state = {
  headers: [
    {
      text: "No",
      align: "start",
      value: "id",
      sortable: true,
      editable: false,
      headerEditable: false,
      fixed: true,
    },
    { text: "Description", value: "description", editable: true, fixed: true },
    { text: "Weight", value: "weight", editable: true },
    {
      text: "Step1",
      value: "step1",
      sortable: false,
      editable: true,
      headerEditable: true,
      // Added by MMG
      columnDeleteIcon: false,
    },

    { text: "Fulfillment", value: "fulfillment", editable: false },
  ],
  deliverables: [],
  steps: [{ text: "Step1", identity: "step1" }],
  responsibles: [],
  nextColumnName: "Step2",
  newRowCounter: 0,
  authState: null,
  authUser: null,
  toasts: [],
  deleteDialog: {
    show: false,
    title: null,
    description: null,
    itemType: null,
    ids: null,
    action: null,
  },
  showProfileDialog: false,
  subscription: null,
  subLog: [],
};

const getChildren = (node) => {
  if (!node) return [];
  return Array.isArray(node.children) ? node.children : [];
};

const collectLeaves = (items) => {
  const leaves = [];
  const traverse = (list) => {
    if (!Array.isArray(list)) return;
    list.forEach((node) => {
      const children = getChildren(node);
      if (node && children.length > 0) {
        traverse(children);
      } else if (node) {
        leaves.push(node);
      }
    });
  };
  traverse(items);
  return leaves;
};

const collectLeavesForItem = (item) => {
  const children = getChildren(item);
  if (children.length === 0) {
    return [];
  }
  return collectLeaves(children);
};

const collectSubprojects = (items) => {
  const subs = [];
  const traverse = (list) => {
    if (!Array.isArray(list)) return;
    list.forEach((node) => {
      const children = getChildren(node);
      if (node && children.length > 0) {
        subs.push(node);
        traverse(children);
      }
    });
  };
  traverse(items);
  return subs;
};

const mutations = {
  SET_DELETE_DIALOG(state, { show, ids, title, description, itemType, action }) {
    state.deleteDialog = { show, ids, title, description, itemType, action };
  },
  incrementNewRowCounter(state) {
    state.newRowCounter++;
  },
  SET_ROW_COUNTER_TO_ZERO(state, value) {
    state.newRowCounter = value;
  },
  SET_HEADERS(state, headers) {
    state.headers = headers;
  },
  SET_TABLE_STATE(state, deliverables) {
    state.deliverables = deliverables;
  },
  SET_STEPS(state, steps) {
    state.steps = steps;
    state.nextStatusColumn = "Step" + (state.steps.length + 1);
  },
  SET_RESPONSIBLES(state, responsibles) {
    state.responsibles = responsibles;
  },
  SET_NEXT_COLUMN_NAME(state, nextColumnName) {
    state.nextColumnName = nextColumnName;
  },
  LOAD_DELIVERABLES(state, loadedArray) {
    if (state.steps.length > 0) {
      state.deliverables = loadedArray;
    }
  },
};

const actions = {
  setSubLog({ commit, state, dispatch }, data) {
    // state.subLog = [...state.subLog, data];
    // state.subLog = [state.subLog, data];
    let getlogdata = JSON.parse(localStorage.getItem("subLog")) || []; // Load from localStorage or start empty
    // let subLogData = [];
    if (data) {
      getlogdata.push(data);
      // state.subLog = subLogData;
      localStorage.setItem("subLog", JSON.stringify(getlogdata)); // Persist to localStorage
    }
  },
  addToast({ commit, state, dispatch }, toast) {
    // console.log("toast action trigger", toast);
    state.toasts = [];
    const id = `toast_${
      Math.random()
        .toString()
        .split(".")[1]
    }`;
    toast = { id: id, ...toast };
    if (toast.life == undefined) {
      toast.life = 3000;
    }

    state.toasts.push(toast);
    if (toast.life > 0) {
      setTimeout(() => dispatch("removeToast", id), toast.life);
    }
    state.showToast = true;
    return toast;
  },
  removeToast({ commit, state }, toastId) {
    state.toasts = [...state.toasts.filter((toast) => toast.id != toastId)];
  },
  setSubStatus({ commit, state, dispatch }, value) {
    state.authUser = { ...(state.authUser || {}), subStatus: value };
  },
  setSubID({ commit, state, dispatch }, value) {
    state.authUser = { ...(state.authUser || {}), subID: value };
  },
  setUserToken({ commit, state, dispatch }, value) {
    state.authUser = { ...(state.authUser || {}), token: value };
  },
  setLastPayment({ commit, state }, value) {
    state.authUser = { ...(state.authUser || {}), lastPayment: value };
  },
  toggleProfileDialog({ commit, state, dispatch }) {
    if (state.showProfileDialog === true) {
      state.showProfileDialog = false;
    } else state.showProfileDialog = true;
  },
  setDeleteDialog({ commit }, { show, ids = null, title, description, itemType, action }) {
    const idArray = Array.isArray(ids) ? ids : [ids];
    commit("SET_DELETE_DIALOG", { show, ids: idArray, title, description, itemType, action });
  },
  setAuthState({ commit, state, dispatch }, value) {
    state.authState = value.state;
    state.authUser = value.user;
  },
  setNextBillingTime({ commit, state, dispatch }, value) {
    state.authUser = { ...(state.authUser || {}), ...value };
  },
  incrementNewRowCounterAction({ commit }) {
    commit("incrementNewRowCounter");
  },
  setRowCounterToZero({ commit }, value) {
    commit("SET_ROW_COUNTER_TO_ZERO", value);
  },
  setHeaders: ({ commit }, headers) => {
    commit("SET_HEADERS", headers);
  },
  setDeliverables: ({ commit }, deliverables) => {
    commit("SET_TABLE_STATE", deliverables);
  },
  setSteps: ({ commit }, steps) => {
    commit("SET_STEPS", steps);
  },
  setResponsibles: ({ commit }, responsibles) => {
    commit("SET_RESPONSIBLES", responsibles);
  },
  setNextColumnName: ({ commit, state }, columnType) => {
    let nextColumnName = "Step";
    if (columnType === "Status") {
      nextColumnName = "Step" + (state.steps.length + 1);
    } else if (columnType === "Responsible") {
      if (state.responsibles.length === 0) {
        nextColumnName = "Responsible";
      } else {
        nextColumnName = "Responsible" + (state.steps.length + 1);
      }
    }
    commit("SET_NEXT_COLUMN_NAME", nextColumnName);
  },
  loadDeliverables: ({ commit }, loadedArray) => {
    commit("LOAD_DELIVERABLES", loadedArray);
  },
};

const getters = {
  getLogData: (state) => {
    return state.subLog;
  },
  getToasts: (state) => {
    return state.toasts;
  },
  getNewRowCounter: (state) => {
    return state.newRowCounter;
  },
  getAuth: (state) => {
    return state.authState;
  },
  getAuthData: (state) => {
    return state.authUser;
  },
  getSubID: (state) => {
    return state.authUser?.subID;
  },
  getSubStatus: (state) => {
    return state.authUser?.subStatus;
  },
  getLastPayment: (state) => {
    return state.authUser?.lastPayment;
  },
  getNextBillingtime: (state) => {
    return state.authUser?.nextBillingTime;
  },
  getUserToken: (state) => {
    return state.authUser?.token;
  },
  getNextColumnName: (state) => (columnType) => {
    let nextColumnName = "Step";
    if (columnType === "Status") {
      nextColumnName = "Step" + (state.steps.length + 1);
    } else if (columnType === "Responsible") {
      if (state.responsibles.length === 0) {
        nextColumnName = "Responsible1";
      } else {
        nextColumnName = "Responsible" + (state.responsibles.length + 1);
      }
    }
    return nextColumnName;
  },
  headers: (state) => {
    return state.headers;
  },
  deliverables: (state) => {
    return state.deliverables;
  },
  steps: (state) => {
    return state.steps;
  },
  responsibles: (state) => {
    return state.responsibles;
  },

  stepsFulfillment: (state) => {
    if (!Array.isArray(state.steps) || state.steps.length === 0) {
      return {};
    }

    const HALF = 0.5;
    const leaves = collectLeaves(state.deliverables);
    const fulfillmentsObj = {};

    state.steps.forEach((step) => {
      if (!step) return;
      let totalWeights = 0;
      let wipCount = 0;
      let closedCount = 0;

      leaves.forEach((row) => {
        const weight = toNumber(asFraction(row.weight));
        if (row[step.identity] !== "n.rel.") {
          totalWeights += weight;
        }
        closedCount += row[step.identity] === "closed" ? weight : 0;
        wipCount += row[step.identity] === "wip" ? weight * HALF : 0;
      });

      fulfillmentsObj[step.identity] =
        totalWeights === 0 ? STATUS_NREL : ((closedCount + wipCount) / totalWeights) * 100;
    });
    return fulfillmentsObj;
  },

  subProjectStepsFullFilment: (state) => {
    if (!Array.isArray(state.steps) || state.steps.length === 0) {
      return {}; // or return some default value
    }

    const fulfillmentsObj = {};
    const subprojects = collectSubprojects(state.deliverables);
    const HALF = 0.5;

    subprojects.forEach((item) => {
      const leaves = collectLeavesForItem(item);
      fulfillmentsObj[item.id] = {};

      state.steps.forEach((step) => {
        if (!step) return;
        let totalWeights = 0;
        let wipCount = 0;
        let closedCount = 0;

        leaves.forEach((row) => {
          const weight = toNumber(asFraction(row.weight));
          if (row[step.identity] !== "n.rel.") {
            totalWeights += weight;
          }
          closedCount += row[step.identity] === "closed" ? weight : 0;
          wipCount += row[step.identity] === "wip" ? weight * HALF : 0;
        });

        fulfillmentsObj[item.id][step.identity] =
          totalWeights === 0 ? STATUS_NREL : ((closedCount + wipCount) / totalWeights) * 100;
      });
    });

    return fulfillmentsObj;
  },

  totalFulfillment: (state) => {
    if (!Array.isArray(state.steps) || state.steps.length === 0) {
      return 0;
    }

    let sumAll = R(0);
    let totalWeights = R(0);
    const leaves = collectLeaves(state.deliverables);

    leaves.forEach((item) => {
      if (item.fulfillment !== "n.rel.") {
        const weight = asFraction(item.weight);
        const fulfillment =
          typeof item.fulfillment === "number" ? R(item.fulfillment, 100) : asFraction(item.fulfillment);
        totalWeights = totalWeights.add(weight);
        sumAll = sumAll.add(fulfillment.mul(weight));
      }
    });

    if (totalWeights.equals(0)) {
      return 0;
    }

    return toPercentNumber(sumAll.div(totalWeights));
  },

  nextResponsibleIdentity: (state) => {
    if (state.responsibles.length === 0) {
      return "responsible1";
    } else {
      return "responsible" + (state.responsibles.length + 1);
    }
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
